export default "__VITE_ASSET__Crci3bcD__"